// autogenerated
import {AthenaeumConstants, ServiceProvider} from "@reapptor-apps/reapptor-toolkit";
import {ETagRequest} from "@reapptor-apps/reapptor-react-common";

export default class ListShuttleWaypointsRequest extends ETagRequest {

    public sourceServicePointId: string | null = null;

    public activeOnly: boolean = false;

    public readonly isListShuttleWaypointsRequest: true = true;

    public static is(from?: object | null): boolean {
        // noinspection PointlessBooleanExpressionJS
        return (from != null) && ((from instanceof ListShuttleWaypointsRequest) || ((from as any).isListShuttleWaypointsRequest === true));
    }

    public static as(from?: object | null): ListShuttleWaypointsRequest | null {
        return (ListShuttleWaypointsRequest.is(from)) ? from as ListShuttleWaypointsRequest : null;
    }

    // #region Placeholder

    // Put your code here (function, properties, ect...)

    // #endregion
}

ServiceProvider.addType(ListShuttleWaypointsRequest, "ListShuttleWaypointsRequest");